import { useCallback, useEffect, useState, useTransition } from 'react'

import Cookies from 'js-cookie'
import dynamic from 'next/dynamic'
import { useIntl } from 'react-intl'

import ErrorBoundary from 'components/templates/navigatorLayout/errorBoundary'
import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import {
  ENABLE_ACCEPT_COOKIE_MODAL_LOCALES,
  ENV,
  GTM_CONSENT_COOKIE,
  STATIC_PAGES,
  basePath,
} from 'interfaces/constants'

// const WelcomePopup = dynamic(() =>
//   import('components/organisms/welcomePopup').then((mod) => mod.WelcomePopup),
// )

// const OnboardingSigninWrapper = dynamic(
//   () => import('components/organisms/onboardingSignin/wrapper'),
//   { ssr: false },
// )
const LeavePageConfirmPopupWrapper = dynamic(
  () =>
    import('components/atoms/leavePageConfirmPopup/wrapper').then(
      (mod) => mod.LeavePageConfirmPopupWrapper,
    ),
  { ssr: false },
)
const CookieAcceptConfirm = dynamic(
  () =>
    import('@hhgtech/hhg-components/components').then(
      (mod) => mod.CookieAcceptConfirm,
    ),
  { ssr: false },
)

const BelowMainContent = () => {
  const {
    locale,
    router: { asPath },
  } = useRouterExtend()
  // const { ref, inView } = useInView({
  //   rootMargin: `-120px 0px 0px 0px`,
  // })

  const [openAcceptCookieModal, setOpenAcceptCookieModal] = useState(false)
  const [mount, setMount] = useState(false)
  const [_, startTransition] = useTransition()

  const { formatMessage: f } = useIntl()

  useEffect(() => {
    startTransition(() => {
      setOpenAcceptCookieModal(
        ENABLE_ACCEPT_COOKIE_MODAL_LOCALES.includes(locale) &&
          typeof window !== 'undefined' &&
          !Cookies.get(GTM_CONSENT_COOKIE),
      )
    })
    setTimeout(() => {
      startTransition(() => {
        setMount(true)
      })
    }, 5000)
  }, [])

  useEffect(() => {
    const bodyEle = document.getElementsByTagName('body')[0]
    if (openAcceptCookieModal) {
      bodyEle.classList.add('hasCookieConfirm')
    } else {
      bodyEle.classList.remove('hasCookieConfirm')
    }
  }, [openAcceptCookieModal])

  const onAcceptCookie = useCallback(() => {
    const consentUpdate = {
      adConsentGranted: true,
      analyticsConsentGranted: true,
      functionalityConsentGranted: true,
      personalizationConsentGranted: true,
      securityConsentGranted: true,
    }
    Cookies.set(GTM_CONSENT_COOKIE, JSON.stringify(consentUpdate), {
      domain:
        ENV.NEXT_PUBLIC_DEPLOY_ENV === 'development'
          ? 'localhost'
          : `.${domainLocales[locale]}`,
    })
    setOpenAcceptCookieModal(false)

    if (typeof window !== 'undefined') {
      window.consentListeners.forEach(
        (callback: (consentUpdateData: typeof consentUpdate) => void) => {
          callback(consentUpdate)
        },
      )
    }
  }, [setOpenAcceptCookieModal])

  return (
    <>
      <div
        id="mantine-modal-target"
        style={{ position: 'relative', zIndex: 305 }}
      >
        {mount && (
          <>
            {/* <ErrorBoundary>
              <OnboardingSigninWrapper />
            </ErrorBoundary> */}
            <ErrorBoundary>
              <LeavePageConfirmPopupWrapper />
            </ErrorBoundary>
          </>
        )}
      </div>
      {openAcceptCookieModal && mount ? (
        <ErrorBoundary>
          <CookieAcceptConfirm
            theme="helloSites"
            className="cookie-confirm-box"
            title={f({
              id: 'cookiePolicies.modal.title',
              defaultMessage: 'Please accept our privacy policy',
            })}
            description={f({
              id: 'cookiePolicies.modal.description',
              defaultMessage:
                'Hello Health Group uses cookies to improve your experience and to show you personalized ads',
            })}
            policiesUrl={`/static${
              STATIC_PAGES[locale]?.PRIVACY_POLICY || '/'
            }`}
            onAcceptClick={onAcceptCookie}
            translations={{
              acceptButton: f({
                id: 'cookiePolicies.modal.accept',
                defaultMessage: 'Accept',
              }),
              policiesButton: f({
                id: 'cookiePolicies.modal.ourPolicies',
                defaultMessage: 'Our Policies',
              }),
            }}
            trackingAttributes={{
              dataEventCategory: 'Consent Pop Up',
              dataEventAction: 'Accept Click',
              dataEventLabel: `https://${domainLocales[locale]}${basePath}${asPath}`,
            }}
          />
        </ErrorBoundary>
      ) : undefined}
    </>
  )
}

export { BelowMainContent }
